import React from 'react';
import { CookiesProvider } from 'react-cookie';
// Import User Provider
import { UserProvider } from 'engine/Contexts/User.context';
import { ThemeContextProvider } from 'engine/Contexts/Theme.context';
// Import Notifications Provider
//import { NotificationsContextProvider } from 'engine/Contexts/Notifications.context';

function AppProviders({ children }) {
  return (
    <CookiesProvider>
      <UserProvider>
        <ThemeContextProvider>
          {children}
        </ThemeContextProvider>
      </UserProvider>
    </CookiesProvider>
  );
}

export { AppProviders };